import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { PageNotFoundComponent } from '../components/pagenotfound';

const root: HTMLElement | null = document.getElementById('react-root-element');
if (root != null) {
  root.setAttribute('neon-react-root', '');
  createRoot(root).render(
    <BrowserRouter>
      <Routes>
        <Route path="/districtnotfound" element={<PageNotFoundComponent />} />
        <Route path="*" element={<Navigate to="/districtnotfound" replace />} />
      </Routes>
    </BrowserRouter>
  );
}